import { Icon } from '@ab-core/icon';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { StyledIconsContainer } from './styled';

export type IconsContainerStyleType = ScalableStyle<{
    isVisible: boolean;
}>;

export type IconsContainerProps = {
    hasCredits?: boolean;
    hasDiscount?: boolean;
};

export const IconsContainer: FC<IconsContainerProps & IconsContainerStyleType> = (props) => {
    const { hasCredits = false, hasDiscount = false, scalableStyle } = props;

    if (!scalableStyle?.isVisible) {
        return <></>;
    }

    return (
        <StyledIconsContainer>
            {hasDiscount && <Icon name="Discount" />}
            {hasCredits && <Icon name="Credits" />}
        </StyledIconsContainer>
    );
};
